<template>
    <div>
        <Collapse v-model="value" simple style="border:0">
            <Panel name="1" hide-arrow style="margin: 20px 0;border:0" >
                <FormTitle :titleText="$t('Apply_Training_Record')"/><!-- 培训记录 -->
                <div slot="content" style="margin-top: 40px;">
                    <Table border :loading="loading" :columns="columns" :data="data"> </Table>
                    <div style="margin:20px 0;">
                        <Page style="float: right" :total="total" @on-change="pageChange"/>
                    </div>
                </div>
            </Panel>
            <div  v-if="id==''">
                <span style="color: red;">{{$t('EmpFilesComment')}}</span>
            </div> 
        </Collapse>
    </div>
</template>

<script>
import axios from 'axios'
import DateUtil from "@/util/DateUtil";
export default {
    data(){
        return{
            formItem:{},
            list:[],
            value:[1],
            date: new DateUtil(),
            loading:false,
            pageInfo: {
                itemCount: 0,
                pageNo: 1,
                pageSize: 10,
            },
            total: 0,
            data:[],
            id:'',
            serialnumber:'',
            finishList:[
                {value:'0',label:'否'},
                {value:'1',label:'是'}
            ]
        }
    },
    computed:{
        columns(){
            return [
                {
                    title: this.$t('Training_Academy_'),/* 培训课程 */
                    key: "traintype",
                    align: "center",
                    minWidth: 120,
                    ellipsis:true,
                    
                },{
                    title: this.$t('Start_Date'),/* 开始日期 */
                    key: "begindate",
                    align: "center",
                    minWidth: 120,
                    ellipsis:true,
                    render: (h, params) => {
                        return h(
                            "span",
                            this.date.dateVal(params.row.begindate, "YYYY-MM-DD")
                        );
                    },
                },{
                    title: this.$t('End_Date'),/* 结束日期 */
                    key: "enddate",
                    align: "center",
                    minWidth: 120,
                    ellipsis:true,
                    render: (h, params) => {
                        return h(
                            "span",
                            this.date.dateVal(params.row.enddate, "YYYY-MM-DD")
                        );
                    },
                },{
                    title: this.$t('Training_Days'),/* 培训天数 */
                    key: "days",
                    align: "center",
                    minWidth: 120,
                    ellipsis:true,
                    
                },{
                    title: this.$t('Tranier_'),/* 培训员 */
                    key: "trainer",
                    align: "center",
                    minWidth: 120,
                    ellipsis:true,
                },{
                    title: this.$t('Whether_Completed'),/* 是否完成 */
                    key: "finish",
                    align: "center",
                    minWidth: 120,
                    ellipsis:true,
                    render: (h, params) => {
                        return h(
                        "span",
                            this.finishList.filter(
                            item => params.row.finish == item.value
                            ).map(res => res.label)
                        );
                    }
                },{
                    title: this.$t('Training_Results'),/* 培训成绩 */
                    key: "grade",
                    align: "center",
                    minWidth: 120,
                    ellipsis:true,
                },
            ]
        }
    },
    methods:{
        getData(val){
            this.loading=true
            val?this.serialnumber=val:this.serialnumber=JSON.parse(sessionStorage.getItem("userInfo")).serialnumber
            axios.post("/traingRecords/getTraingRecords", {...this.pageInfo,serialnumber:this.serialnumber}).then((res) => {
                this.loading=false
                if (res) {
                   this.data=res.data
                   this.total=parseInt(res.pageInfo.total)
                }
            })
        },
        pageChange(val){
            this.pageInfo.pageNo = val
        },
    }
}
</script>

<style lang="less" scoped>
.btnfooter {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
}
</style>



// WEBPACK FOOTER //
// src/components/process/files/components/TrainingRecord.vue